import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import * as uuid from 'uuid';

declare const document: any;

export const getScript = (src: string) => {
    const script = document.createElement('script');
    script.id = `s-${uuid.v4()}`;
    script.src = src;
    script.async = true;
    script.onload = () => { };
    document.body.append(script);
}
